<template>
  <div :class="$attrs.class">
    <router-link class="tw-overflow-hidden md:tw-rounded-3xl md:tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-flex tw-items-center md:tw-block" :to="{ name: 'category', params: { id:  category.id}}">
      <div class="tw-overflow-hidden tw-block md:tw-h-auto tw-w-40 md:tw-w-full tw-relative tw-grow-0 tw-shrink-0">
        <img 
          :alt="category.name+' image'"
          class="tw-scale-105 md:tw-h-full tw-w-full group-hover:tw-scale-110 tw-transition-all tw-duration-300 tw-ease-out"
          :src="categoryImage">
      </div>
      
      <div class="tw-px-8 tw-py-8 md:tw-text-center tw-font-black tw-w-full tw-block tw-text-3xl lg:tw-text-2xl">
        {{category.name}}
      </div>
    </router-link>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import type MenuCategory from '../../classes/MenuCategory';

const props = defineProps<{ category: MenuCategory }>();

const categoryImage = ref();

onMounted(() => {
  if (props.category && props.category.images) {
    let img = props.category.getImageByKey("category_web_list")

    if (img) {
      categoryImage.value = img.url
    } else {
      categoryImage.value = 'https://mypiada-assets.s3.amazonaws.com/static_assets/scooter-placeholder.jpg';
    }
  }
})

</script>
